import React from 'react'

import { SearchApiResult } from '../../services/api'
import { ComboBoxItem, ComboBoxItemProps } from '../combo-box'
import { Highlight } from '../highlight'
import { PropsWithAs } from '../types'

interface SearchItemProps extends Pick<ComboBoxItemProps, 'state'> {
  item: SearchApiResult
  chartIndex?: number
  itemProps: Partial<PropsWithAs<React.ElementType>>
}

export function SearchItem(props: SearchItemProps) {
  return (
    <ComboBoxItem
      {...props.itemProps}
      state={props.state}
      value={props.item.ticker}
      className="h-auto min-h-7 w-full shrink-0 appearance-none py-1 leading-snug"
      contentClass="flex overflow-hidden px-1 -mx-1"
      data-testid={
        props.chartIndex !== undefined
          ? `chart-${props.chartIndex}-settings-suggestion-${props.item.ticker}`
          : undefined
      }
    >
      <span className="w-16">
        <Highlight text={props.item.ticker} highlight={props.state!.inputValue} />
      </span>
      <span className="-mx-1 flex-1 whitespace-normal px-1 text-gray-600 dark:text-gray-200">
        <Highlight text={props.item.company} highlight={props.state!.inputValue} />
      </span>
      <span className="ml-2 uppercase text-gray-400">{props.item.exchange}</span>
    </ComboBoxItem>
  )
}
